"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var cross_fetch_1 = require("cross-fetch");
var stringify = require("json-stable-stringify");
var INFLIGHT_WINDOW_KEY = 'ksys_requests_inflight';
var COMPLETED_WINDOW_KEY = 'ksys_requests_completed';
if (!global[INFLIGHT_WINDOW_KEY]) {
    global[INFLIGHT_WINDOW_KEY] = {};
}
if (!global[COMPLETED_WINDOW_KEY]) {
    global[COMPLETED_WINDOW_KEY] = {};
}
var inflightRequests = global[INFLIGHT_WINDOW_KEY];
var completedRequests = global[COMPLETED_WINDOW_KEY];
var CachableRequest = /** @class */ (function () {
    function CachableRequest(url, request, debug) {
        if (debug === void 0) { debug = false; }
        this.subscribers = [];
        this.url = url;
        this.request = request;
        this.key = this.getKey();
        this.debug = debug;
    }
    CachableRequest.prototype.getKey = function () {
        var keyObject = {
            url: this.url,
            request: this.request,
        };
        return stringify(keyObject);
    };
    CachableRequest.prototype.fetch = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var inflightRequest, completedRequest, _a, error_1;
                        var _this = this;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    inflightRequest = inflightRequests[this.key];
                                    completedRequest = completedRequests[this.key];
                                    if (!(inflightRequest && !completedRequest)) return [3 /*break*/, 1];
                                    if (this.debug) {
                                        console.info("Request INFLIGHT: " + this.key);
                                    }
                                    if (!inflightRequest.subscribers) {
                                        inflightRequest.subscribers = [];
                                    }
                                    inflightRequest.subscribers.push(function (response) {
                                        _this.response = response.clone();
                                        resolve(_this.response);
                                    });
                                    return [3 /*break*/, 8];
                                case 1:
                                    if (!completedRequest) return [3 /*break*/, 2];
                                    if (this.debug) {
                                        console.info("Request from CACHE: " + this.key);
                                    }
                                    if (inflightRequest) {
                                        delete inflightRequests[this.key];
                                    }
                                    this.response = completedRequest.cleanResponse.clone();
                                    return [3 /*break*/, 7];
                                case 2:
                                    if (this.debug) {
                                        console.info("Request CREATED: " + this.key);
                                    }
                                    inflightRequests[this.key] = this;
                                    _b.label = 3;
                                case 3:
                                    _b.trys.push([3, 5, , 6]);
                                    _a = this;
                                    return [4 /*yield*/, cross_fetch_1.fetch(this.url, this.request)];
                                case 4:
                                    _a.cleanResponse = _b.sent();
                                    this.response = this.cleanResponse.clone();
                                    return [3 /*break*/, 6];
                                case 5:
                                    error_1 = _b.sent();
                                    console.warn('request inner error', error_1);
                                    return [3 /*break*/, 6];
                                case 6:
                                    completedRequests[this.key] = this;
                                    delete inflightRequests[this.key];
                                    if (this.subscribers && this.subscribers.length > 0) {
                                        this.subscribers.forEach(function (subscriber) { return subscriber(_this.cleanResponse); });
                                    }
                                    _b.label = 7;
                                case 7:
                                    resolve(this.response);
                                    _b.label = 8;
                                case 8: return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    return CachableRequest;
}());
exports.CachableRequest = CachableRequest;
//# sourceMappingURL=CachableRequest.js.map